/* =============================================================================
   Ella Custom JS - Customize The Style For Layout
   ============================================================================= */

(function () {
  function getShopifyRoot() {
    return window.Shopify?.routes?.root || window.routes?.root || '/';
  }

  function buildShopifyUrl(path) {
    const root = getShopifyRoot();
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
    return new URL(path.replace(/^\//, ''), window.location.origin + normalizedRoot).toString();
  }

  async function parseJsonResponse(response) {
    const contentType = response.headers.get('content-type') || '';
    const bodyText = await response.text();
    const trimmedBody = bodyText.trim();

    if (!trimmedBody) {
      return {};
    }

    const looksLikeJson =
      contentType.includes('application/json') ||
      trimmedBody.startsWith('{') ||
      trimmedBody.startsWith('[');

    if (looksLikeJson) {
      try {
        return JSON.parse(trimmedBody);
      } catch (error) {
        throw new Error(`Failed to parse server response: ${error.message}`);
      }
    }

    const shortBody = trimmedBody.slice(0, 120);
    throw new Error(
      shortBody
        ? `Unexpected response from server: ${shortBody}`
        : `Unexpected response from server (${response.status})`
    );
  }

  function normalizeItems(items) {
    const normalizedItems = items.map((item) => ({
      id: Number(item.id),
      quantity: Number(item.quantity) || 1,
    }));

    if (normalizedItems.some((item) => !Number.isFinite(item.id) || item.id <= 0)) {
      throw new Error('Invalid product variant');
    }

    return normalizedItems;
  }

  function buildCheckoutPermalink(items) {
    const normalizedItems = normalizeItems(items);
    const lineItemsPath = normalizedItems
      .map((item) => `${encodeURIComponent(item.id)}:${encodeURIComponent(item.quantity)}`)
      .join(',');

    return buildShopifyUrl(`/cart/${lineItemsPath}?checkout`);
  }

  function redirectToCheckout(url) {
    if (window.halo?.redirectTo) {
      window.halo.redirectTo(url);
      return;
    }

    try {
      if (window.self !== window.top && window.top?.location) {
        window.top.location.href = url;
        return;
      }
    } catch (error) {
      // Ignore cross-origin access errors and fall back to same-frame navigation.
    }

    window.location.assign(url);
  }

  async function replaceCartAndGoToCheckout(items) {
    redirectToCheckout(buildCheckoutPermalink(items));
  }

  window.LinyoCheckout = {
    buildCheckoutPermalink,
    buildShopifyUrl,
    replaceCartAndGoToCheckout,
  };

  function isElementVisible(element) {
    if (!element) {
      return false;
    }

    const style = window.getComputedStyle(element);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      element.getClientRects().length > 0
    );
  }

  function rememberButtonState(button) {
    if (!button) {
      return;
    }

    if (!button.dataset.linyoOriginalHtml) {
      button.dataset.linyoOriginalHtml = button.innerHTML;
    }
  }

  function setButtonLoading(button, label) {
    if (!button) {
      return;
    }

    rememberButtonState(button);
    button.dataset.linyoProcessing = 'true';
    button.innerHTML = label || 'Processing...';
    button.style.pointerEvents = 'none';
    button.disabled = true;
  }

  function restoreButton(button) {
    if (!button) {
      return;
    }

    if (button.dataset.linyoOriginalHtml) {
      button.innerHTML = button.dataset.linyoOriginalHtml;
    }

    button.style.pointerEvents = '';
    button.disabled = false;
    delete button.dataset.linyoProcessing;
  }

  function resetProcessingButtons() {
    document.querySelectorAll('[data-linyo-processing="true"]').forEach(restoreButton);
  }

  function getProductFormFromButton(button) {
    return (
      button?.closest('form[data-type="add-to-cart-form"]') ||
      button?.closest('product-form')?.querySelector('form[data-type="add-to-cart-form"]') ||
      button?.closest('.productView-form')?.querySelector('form[data-type="add-to-cart-form"]') ||
      button?.closest('[data-sticky-add-to-cart]')?.querySelector('form[data-type="add-to-cart-form"]') ||
      button?.closest('form') ||
      null
    );
  }

  function getCheckoutQuantity(button, productForm) {
    const candidateInputs = [];
    const pushInputs = (root) => {
      if (!root) {
        return;
      }

      root.querySelectorAll('input[name="quantity"]').forEach((input) => {
        if (!candidateInputs.includes(input)) {
          candidateInputs.push(input);
        }
      });
    };

    pushInputs(button?.parentElement);
    pushInputs(button?.closest('[data-sticky-add-to-cart]'));
    pushInputs(button?.closest('.productView-payment'));
    pushInputs(button?.closest('.productView'));
    pushInputs(productForm);

    const preferredInput =
      candidateInputs.find((input) => isElementVisible(input)) || candidateInputs[0] || null;

    return Math.max(parseInt(preferredInput?.value || '1', 10) || 1, 1);
  }

  function getCheckoutContext(button) {
    const productForm = getProductFormFromButton(button);
    const variantInput = productForm?.querySelector('[name="id"]');
    const variantId = Number(variantInput?.value);
    const quantity = getCheckoutQuantity(button, productForm);

    return {
      productForm,
      variantId,
      quantity,
    };
  }

  window.LinyoPayDeposit = {
    getCheckoutContext,
    resetProcessingButtons,
    restoreButton,
    setButtonLoading,
  };

  function getAssetUrl(filename) {
    const script = document.querySelector('script[src*="custom.js"]');

    if (!script) {
      return filename;
    }

    return script.src.replace(/custom\.js(?:\?.*)?$/, filename);
  }

  function isTargetTemplate() {
    return (
      document.body.classList.contains('template-index') ||
      document.body.classList.contains('template-product')
    );
  }

  function isDesktopViewport() {
    return window.matchMedia('(min-width: 1025px)').matches;
  }

  function syncAnnouncementStickyGroup() {
    const wrapper = document.querySelector('.body-content-wrapper');
    const announcementBar = document.querySelector('announcement-bar-component');
    const targetGroup = announcementBar?.closest('.shopify-section-group-header-group');
    const groups = document.querySelectorAll('.shopify-section-group-header-group');
    const shouldUseStickyGroup = Boolean(announcementBar && targetGroup) && !isDesktopViewport();
    const shouldUseDesktopStickyGroups = Boolean(announcementBar && targetGroup) && isDesktopViewport() && isTargetTemplate();
    const announcementHeight = announcementBar ? Math.ceil(announcementBar.getBoundingClientRect().height) : 0;

    document.documentElement.style.setProperty('--linyo-announcement-height', `${announcementHeight}px`);

    groups.forEach((group) => {
      group.classList.toggle('linyo-announcement-sticky-group', shouldUseStickyGroup && group === targetGroup);
      group.classList.toggle('linyo-desktop-announcement-sticky-group', shouldUseDesktopStickyGroups && group === targetGroup);
    });

    if (!wrapper) {
      return;
    }

    wrapper.style.removeProperty('padding-top');

    if (!shouldUseStickyGroup) {
      return;
    }

    wrapper.style.paddingTop = `${announcementHeight}px`;
  }

  function createBackToTopButton() {
    if (!isTargetTemplate() || document.querySelector('.linyo-back-to-top')) {
      return;
    }

    const button = document.createElement('button');
    const iconUrl = getAssetUrl('back-top.svg');
    button.type = 'button';
    button.className = 'linyo-back-to-top';
    button.setAttribute('aria-label', 'Back to top');
    button.innerHTML = `<span class="linyo-back-to-top__icon" aria-hidden="true"><img src="${iconUrl}" alt="" loading="lazy"></span>`;

    const toggleVisibility = () => {
      button.classList.toggle('is-visible', window.scrollY > 300);
    };

    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();
    document.body.appendChild(button);
  }

  function highlightFirstProductFeature() {
    if (!document.body.classList.contains('template-product')) {
      return;
    }

    let featureMarked = false;

    document.querySelectorAll('.productView-price').forEach((priceBlock) => {
      if (featureMarked) {
        return;
      }

      const priceItem = priceBlock.closest('.productView-moreItem');

      if (!priceItem) {
        return;
      }

      let nextItem = priceItem.nextElementSibling;

      while (nextItem) {
        if (nextItem.querySelector('.product-customInformation')) {
          nextItem.classList.add('linyo-first-product-feature');
          featureMarked = true;
          break;
        }

        nextItem = nextItem.nextElementSibling;
      }
    });

    if (!featureMarked) {
      const fallbackFeature = document.querySelector('.productView-details .product-customInformation, .productView .product-customInformation');

      if (fallbackFeature) {
        const wrapper = fallbackFeature.closest('.productView-moreItem');

        if (wrapper) {
          wrapper.classList.add('linyo-first-product-feature');
        }
      }
    }
  }

  function initOrderProofRotation() {
    if (!document.body.classList.contains('template-product')) {
      return;
    }

    const summaryRotationMs = 5 * 60 * 1000;
    const summaryPresets = [
      { people: 12, minutes: 8 },
      { people: 9, minutes: 13 },
      { people: 15, minutes: 6 },
      { people: 11, minutes: 17 },
      { people: 14, minutes: 9 },
      { people: 8, minutes: 21 },
      { people: 13, minutes: 11 },
      { people: 10, minutes: 16 },
    ];
    const usernames = [
      'gaoyuan',
      'michael',
      'sophialee',
      'alexchen',
      'daniel88',
      'olivia',
      'jasonwu',
      'emilyz',
    ];
    const messages = usernames.map((username) => `${maskUsername(username)} placed an order successfully`);

    function getSummaryText() {
      const slot = Math.floor(Date.now() / summaryRotationMs);
      const preset = summaryPresets[slot % summaryPresets.length];
      return `${preset.people} people placed orders ${preset.minutes} minutes ago`;
    }

    function maskUsername(username) {
      if (!username) {
        return '*';
      }

      if (username.length === 1) {
        return username;
      }

      if (username.length === 2) {
        return `${username.charAt(0)}*`;
      }

      return `${username.charAt(0)}${'*'.repeat(username.length - 2)}${username.slice(-1)}`;
    }

    document.querySelectorAll('.linyo-product-order-proof').forEach((proofNode) => {
      if (proofNode.dataset.initialized === 'true') {
        return;
      }

      const summaryNode = proofNode.querySelector('.linyo-product-order-proof__summary');
      const tickerNode = proofNode.querySelector('.linyo-product-order-proof__ticker-text');

      if (!summaryNode || !tickerNode) {
        return;
      }

      const renderSummary = () => {
        summaryNode.textContent = getSummaryText();
      };

      const renderTicker = (nextIndex, animated) => {
        if (!animated) {
          tickerNode.textContent = messages[nextIndex];
          return;
        }

        tickerNode.classList.add('is-leaving');

        window.setTimeout(() => {
          tickerNode.textContent = messages[nextIndex];
          tickerNode.classList.remove('is-leaving');
          tickerNode.classList.add('is-entering');

          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              tickerNode.classList.remove('is-entering');
            });
          });
        }, 220);
      };

      let currentIndex = Math.floor(Date.now() / summaryRotationMs) % messages.length;
      renderSummary();
      renderTicker(currentIndex, false);
      proofNode.dataset.initialized = 'true';

      const msUntilNextSummaryRefresh = summaryRotationMs - (Date.now() % summaryRotationMs);

      window.setTimeout(() => {
        renderSummary();
        window.setInterval(renderSummary, summaryRotationMs);
      }, msUntilNextSummaryRefresh);

      window.setInterval(() => {
        currentIndex = (currentIndex + 1) % messages.length;
        renderTicker(currentIndex, true);
      }, 2800);
    });
  }

  function initLaunchCountdown() {
    document.querySelectorAll('[data-linyo-launch-countdown]').forEach((countdownNode) => {
      if (countdownNode.dataset.initialized === 'true') {
        return;
      }

      const targetTime = countdownNode.dataset.targetTime;
      const targetDate = new Date(targetTime).getTime();

      if (!Number.isFinite(targetDate)) {
        return;
      }

      const dayNode = countdownNode.querySelector('[data-unit="days"]');
      const hourNode = countdownNode.querySelector('[data-unit="hours"]');
      const minuteNode = countdownNode.querySelector('[data-unit="minutes"]');
      const secondNode = countdownNode.querySelector('[data-unit="seconds"]');

      const renderCountdown = () => {
        const now = Date.now();
        const distance = Math.max(targetDate - now, 0);

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (dayNode) dayNode.textContent = String(days).padStart(2, '0');
        if (hourNode) hourNode.textContent = String(hours).padStart(2, '0');
        if (minuteNode) minuteNode.textContent = String(minutes).padStart(2, '0');
        if (secondNode) secondNode.textContent = String(seconds).padStart(2, '0');
      };

      renderCountdown();
      window.setInterval(renderCountdown, 1000);
      countdownNode.dataset.initialized = 'true';
    });
  }

  function getNewsletterFeedbackNode(form) {
    let feedbackNode = form.querySelector('.linyo-newsletter-feedback');

    if (!feedbackNode) {
      feedbackNode = document.createElement('div');
      feedbackNode.className = 'linyo-newsletter-feedback';
      form.appendChild(feedbackNode);
    }

    return feedbackNode;
  }

  function renderNewsletterFeedback(form, type, message, submessage) {
    const feedbackNode = getNewsletterFeedbackNode(form);
    feedbackNode.className = `linyo-newsletter-feedback is-${type}`;
    feedbackNode.innerHTML = '';

    if (message) {
      const messageNode = document.createElement('div');
      messageNode.className = 'linyo-newsletter-feedback__message';
      messageNode.textContent = message;
      feedbackNode.appendChild(messageNode);
    }

    if (submessage) {
      const submessageNode = document.createElement('div');
      submessageNode.className = 'linyo-newsletter-feedback__subtext';
      submessageNode.textContent = submessage;
      feedbackNode.appendChild(submessageNode);
    }
  }

  function getEnglishValidationMessage(field) {
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement)) {
      return '';
    }

    if (field.validity.valueMissing) {
      return 'Please fill out this field.';
    }

    if (field.validity.typeMismatch && field.type === 'email') {
      return 'Please enter a valid email address.';
    }

    if (field.validity.patternMismatch) {
      return 'Please match the requested format.';
    }

    if (field.validity.tooShort) {
      return `Please lengthen this text to ${field.minLength} characters or more.`;
    }

    if (field.validity.tooLong) {
      return `Please shorten this text to no more than ${field.maxLength} characters.`;
    }

    return '';
  }

  function showEnglishValidationMessage(field) {
    const message = getEnglishValidationMessage(field);

    if (!message) {
      return false;
    }

    field.setCustomValidity(message);
    field.reportValidity();
    return true;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function buildNewsletterRequestBody(form, emailValue) {
    const formData = new FormData(form);
    formData.set('form_type', formData.get('form_type') || 'customer');
    formData.set('utf8', formData.get('utf8') || '✓');
    formData.set('contact[email]', emailValue);

    if (!formData.get('contact[tags]')) {
      formData.set('contact[tags]', 'newsletter');
    }

    const params = new URLSearchParams();

    formData.forEach((value, key) => {
      if (typeof value === 'string') {
        params.append(key, value);
      }
    });

    return params;
  }

  function getNewsletterTransportFrame() {
    let iframe = document.getElementById('linyo-newsletter-transport');

    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.id = 'linyo-newsletter-transport';
      iframe.name = 'linyo-newsletter-transport';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.tabIndex = -1;
      iframe.style.position = 'absolute';
      iframe.style.width = '1px';
      iframe.style.height = '1px';
      iframe.style.opacity = '0';
      iframe.style.pointerEvents = 'none';
      iframe.style.border = '0';
      iframe.style.left = '-9999px';
      document.body.appendChild(iframe);
    }

    return iframe;
  }

  function submitNewsletterThroughFrame(form) {
    const iframe = getNewsletterTransportFrame();
    const originalTarget = form.getAttribute('target');
    const originalAction = form.getAttribute('action');

    return new Promise((resolve, reject) => {
      let settled = false;
      let timeoutId = 0;

      const cleanup = () => {
        if (originalTarget) {
          form.setAttribute('target', originalTarget);
        } else {
          form.removeAttribute('target');
        }

        if (originalAction) {
          form.setAttribute('action', originalAction);
        }

        iframe.removeEventListener('load', handleLoad);
        window.clearTimeout(timeoutId);
      };

      const finish = (handler, value) => {
        if (settled) {
          return;
        }

        settled = true;
        cleanup();
        handler(value);
      };

      const handleLoad = () => {
        try {
          const frameWindow = iframe.contentWindow;
          const frameDocument = iframe.contentDocument || frameWindow?.document;
          const href = frameWindow?.location?.href || '';

          if (!frameDocument || href === 'about:blank') {
            return;
          }

          const responseText = frameDocument.documentElement?.textContent?.replace(/\s+/g, ' ').trim() || '';
          const errorNode =
            frameDocument.querySelector('.errors') ||
            frameDocument.querySelector('.newsletter-form__message--error') ||
            frameDocument.querySelector('.custom-newsletter-msg[style]');
          const successNode =
            frameDocument.querySelector('.custom-newsletter-msg') ||
            frameDocument.querySelector('.newsletter-form__message--success');
          const isSuccess =
            href.includes('customer_posted=true') ||
            /thank you for subscribing/i.test(successNode?.textContent || '') ||
            /thank you for subscribing/i.test(responseText);

          if (isSuccess) {
            finish(resolve);
            return;
          }

          const errorText = (errorNode?.textContent || '').replace(/\s+/g, ' ').trim();
          finish(reject, new Error(errorText || 'Something went wrong. Please try again.'));
        } catch (error) {
          finish(reject, new Error('Something went wrong. Please try again.'));
        }
      };

      timeoutId = window.setTimeout(() => {
        finish(reject, new Error('Subscription timed out. Please try again.'));
      }, 15000);

      iframe.addEventListener('load', handleLoad);
      form.setAttribute('target', iframe.name);
      form.setAttribute('action', form.getAttribute('action') || '/contact#slider-newsletter-form');
      HTMLFormElement.prototype.submit.call(form);
    });
  }

  function restoreNewsletterScrollPosition() {
    const storedValue = window.sessionStorage.getItem('linyoNewsletterScrollY');

    if (!storedValue) {
      return;
    }

    window.sessionStorage.removeItem('linyoNewsletterScrollY');
    const targetY = Number(storedValue);

    if (!Number.isFinite(targetY)) {
      return;
    }

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    [0, 180, 600, 1200].forEach((delay) => {
      window.setTimeout(() => {
        window.scrollTo({ top: targetY, behavior: 'auto' });
      }, delay);
    });
  }

  function hasNewsletterSuccessState() {
    return /customer_posted=true|newsletter&form_type=customer/i.test(window.location.href);
  }

  function isTrackedNewsletterForm(form) {
    return Boolean(
      form &&
      form.querySelector('input[name="contact[email]"]') &&
      (
        form.closest('.custom-slider-newsletter') ||
        form.matches('.newsletter-form') ||
        form.matches('.footer__newsletter')
      ) &&
      !form.classList.contains('newsletter-form--popup')
    );
  }

  function getNewsletterFormKey(form) {
    if (!form.dataset.linyoNewsletterKey) {
      const trackedForms = Array.from(document.querySelectorAll('form')).filter((candidateForm) =>
        isTrackedNewsletterForm(candidateForm)
      );
      const formIndex = trackedForms.indexOf(form);
      const sourceKey = formIndex >= 0
        ? `newsletter-form-${formIndex}`
        : (form.id || `newsletter-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`);

      form.dataset.linyoNewsletterKey = sourceKey.replace(/[^a-zA-Z0-9_-]/g, '-');
    }

    return form.dataset.linyoNewsletterKey;
  }

  function getNewsletterMessageAnchor(form) {
    return (
      form.querySelector('.custom-newsletter-group') ||
      form.querySelector('.newsletter-form__field-wrapper') ||
      form
    );
  }

  function renderNewsletterSuccessMessage(form) {
    const anchor = getNewsletterMessageAnchor(form);

    if (!anchor) {
      return;
    }

    form.querySelector('.linyo-newsletter-success')?.remove();

    const successWrapper = document.createElement('div');
    successWrapper.className = 'linyo-newsletter-success';

    const messageNode = document.createElement('div');
    messageNode.className = 'linyo-newsletter-success__message';
    messageNode.textContent = '🎉 Thank you for subscribing!';
    successWrapper.appendChild(messageNode);

    anchor.insertAdjacentElement('afterend', successWrapper);
  }

  function initEnglishValidationPrompts() {
    if (document.documentElement.dataset.linyoEnglishValidationBound === 'true') {
      return;
    }

    document.addEventListener(
      'invalid',
      (event) => {
        const field = event.target;
        const message = getEnglishValidationMessage(field);

        if (message) {
          field.setCustomValidity(message);
        }
      },
      true
    );

    document.addEventListener(
      'input',
      (event) => {
        const field = event.target;

        if (field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement) {
          field.setCustomValidity('');
        }
      },
      true
    );

    document.documentElement.dataset.linyoEnglishValidationBound = 'true';
  }

  function enhanceRenderedNewsletterMessages() {
    document.querySelectorAll('.custom-slider-newsletter').forEach((container) => {
      let messageNode = container.querySelector('.custom-newsletter-msg');
      const messageText = (messageNode?.textContent || '').replace(/\s+/g, ' ').trim();
      const shouldForceSuccessMessage =
        hasNewsletterSuccessState() &&
        window.sessionStorage.getItem('linyoNewsletterSubmitted') === 'true';

      if (shouldForceSuccessMessage && !messageNode) {
        const targetForm = container.querySelector('form');
        if (targetForm) {
          messageNode = document.createElement('div');
          messageNode.className = 'custom-newsletter-msg';
          messageNode.textContent = '🎉 Thank you for subscribing!';
          targetForm.appendChild(messageNode);
        }
      }

      if (!messageNode) {
        return;
      }

      const normalizedText = (messageNode.textContent || '').replace(/\s+/g, ' ').trim();

      if (/thank you for subscribing/i.test(normalizedText) || shouldForceSuccessMessage) {
        messageNode.textContent = '🎉 Thank you for subscribing!';
      }
    });

    if (hasNewsletterSuccessState()) {
      window.sessionStorage.removeItem('linyoNewsletterSubmitted');
    }
  }

  function initSliderNewsletterForm() {
    if (document.documentElement.dataset.linyoNewsletterBound === 'true') {
      return;
    }

    const clearFeedback = (form, emailInput) => {
      const feedbackNode = form?.querySelector('.linyo-newsletter-feedback');
      if (feedbackNode) {
        feedbackNode.remove();
      }
      emailInput?.setCustomValidity('');
    };

    const handleNewsletterSubmit = async (form, event) => {
      const emailInput = form.querySelector('input[name="contact[email]"]');
      const submitButton = form.querySelector('.custom-newsletter-btn');

      if (!emailInput || !submitButton) {
        return;
      }

      form.setAttribute('novalidate', 'novalidate');
      emailInput.setCustomValidity('');
      clearFeedback(form, emailInput);

      const emailValue = emailInput.value.trim();

      if (!emailValue) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showEnglishValidationMessage(emailInput);
        emailInput.focus();
        return;
      }

      if (!isValidEmail(emailValue)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        emailInput.setCustomValidity('Please enter a valid email address.');
        emailInput.reportValidity();
        emailInput.focus();
        return;
      }

      submitButton.innerHTML = 'Submitting...';
      submitButton.disabled = true;
      submitButton.style.pointerEvents = 'none';
      window.sessionStorage.setItem('linyoNewsletterScrollY', String(window.scrollY));
      window.sessionStorage.setItem('linyoNewsletterSubmitted', 'true');
      window.sessionStorage.setItem('linyoNewsletterFormKey', getNewsletterFormKey(form));
    };

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;

        if (!(form instanceof HTMLFormElement) || !form.closest('.custom-slider-newsletter')) {
          return;
        }

        getNewsletterFormKey(form);
        handleNewsletterSubmit(form, event);
      },
      true
    );

    document.addEventListener(
      'input',
      (event) => {
        const input = event.target;

        if (!(input instanceof HTMLInputElement) || !input.matches('.custom-slider-newsletter input[name="contact[email]"]')) {
          return;
        }

        clearFeedback(input.form, input);
      },
      true
    );

    document.documentElement.dataset.linyoNewsletterBound = 'true';
  }

  function initTrackedNewsletterFormSupport() {
    if (document.documentElement.dataset.linyoTrackedNewsletterBound === 'true') {
      return;
    }

    document.querySelectorAll('form').forEach((form) => {
      if (isTrackedNewsletterForm(form)) {
        getNewsletterFormKey(form);
      }
    });

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;

        if (!(form instanceof HTMLFormElement) || !isTrackedNewsletterForm(form)) {
          return;
        }

        const emailInput = form.querySelector('input[name="contact[email]"]');
        const submitButton = form.querySelector('.custom-newsletter-btn, .newsletter-form__button[type="submit"], .newsletter-form__button[name="commit"]');

        if (!emailInput || !submitButton) {
          return;
        }

        const emailValue = emailInput.value.trim();
        const formKey = getNewsletterFormKey(form);

        form.querySelector('.linyo-newsletter-success')?.remove();

        if (!emailValue || !isValidEmail(emailValue)) {
          event.preventDefault();
          event.stopImmediatePropagation();

          if (!emailValue) {
            showEnglishValidationMessage(emailInput);
          } else {
            emailInput.setCustomValidity('Please enter a valid email address.');
            emailInput.reportValidity();
          }

          emailInput.focus();
          return;
        }

        window.sessionStorage.setItem('linyoNewsletterScrollY', String(window.scrollY));
        window.sessionStorage.setItem('linyoNewsletterSubmitted', 'true');
        window.sessionStorage.setItem('linyoNewsletterFormKey', formKey);

        if (!form.closest('.custom-slider-newsletter')) {
          submitButton.dataset.linyoOriginalHtml = submitButton.dataset.linyoOriginalHtml || submitButton.innerHTML;
          submitButton.innerHTML = 'Submitting...';
          submitButton.disabled = true;
          submitButton.style.pointerEvents = 'none';
        }
      },
      true
    );

    document.addEventListener(
      'input',
      (event) => {
        const input = event.target;

        if (!(input instanceof HTMLInputElement) || input.name !== 'contact[email]' || !isTrackedNewsletterForm(input.form)) {
          return;
        }

        input.form?.querySelector('.linyo-newsletter-success')?.remove();
      },
      true
    );

    document.documentElement.dataset.linyoTrackedNewsletterBound = 'true';
  }

  function enhanceRenderedNewsletterMessages() {
    const shouldForceSuccessMessage =
      hasNewsletterSuccessState() &&
      window.sessionStorage.getItem('linyoNewsletterSubmitted') === 'true';
    const submittedKey = window.sessionStorage.getItem('linyoNewsletterFormKey');

    document.querySelectorAll('.custom-slider-newsletter .custom-newsletter-msg, .custom-slider-newsletter .custom-newsletter-msg--subtext').forEach((node) => {
      node.remove();
    });

    if (shouldForceSuccessMessage && submittedKey) {
      const targetForm = document.querySelector(`[data-linyo-newsletter-key="${submittedKey}"]`);

      if (targetForm) {
        renderNewsletterSuccessMessage(targetForm);
      }
    }

    if (hasNewsletterSuccessState()) {
      window.sessionStorage.removeItem('linyoNewsletterSubmitted');
      window.sessionStorage.removeItem('linyoNewsletterFormKey');
    }
  }

  function initLinyoCustomizations() {
    syncAnnouncementStickyGroup();
    initEnglishValidationPrompts();
    createBackToTopButton();
    highlightFirstProductFeature();
    initOrderProofRotation();
    initLaunchCountdown();
    initSliderNewsletterForm();
    initTrackedNewsletterFormSupport();
    restoreNewsletterScrollPosition();
    enhanceRenderedNewsletterMessages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLinyoCustomizations);
  } else {
    initLinyoCustomizations();
  }

  window.addEventListener('resize', syncAnnouncementStickyGroup);
  window.addEventListener('load', syncAnnouncementStickyGroup);
  window.addEventListener('load', resetProcessingButtons);
  window.addEventListener('load', restoreNewsletterScrollPosition);
  window.addEventListener('load', enhanceRenderedNewsletterMessages);
  window.addEventListener('pageshow', resetProcessingButtons);
  window.addEventListener('pageshow', restoreNewsletterScrollPosition);
  window.addEventListener('pageshow', enhanceRenderedNewsletterMessages);
  window.addEventListener('focus', resetProcessingButtons);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      resetProcessingButtons();
      restoreNewsletterScrollPosition();
      enhanceRenderedNewsletterMessages();
    }
  });
})();
